export const PARTNER_AIRBNB_COLUMN_BASE_GUESTS = 'baseGuests';
export const PARTNER_AIRBNB_COLUMN_CANCEL_POLICY = 'cancelPolicy';
export const PARTNER_AIRBNB_COLUMN_LONG_TERM_CANCEL_POLICY = 'longTermCancelPolicy';
export const PARTNER_AIRBNB_COLUMN_CLEANING_FEE = 'cleaningFee';
export const PARTNER_AIRBNB_COLUMN_SHORT_TERM_CLEANING_FEE = 'shortTermCleaningFee';
export const PARTNER_AIRBNB_COLUMN_COMMUNITY_FEE = 'communityFee';
export const PARTNER_AIRBNB_COLUMN_PET_FEE = 'petFee';
export const PARTNER_AIRBNB_COLUMN_INSTANT_BOOKING = 'instantBooking';
export const PARTNER_AIRBNB_COLUMN_GUEST_RATE = 'guestRate';
export const PARTNER_AIRBNB_COLUMN_MANAGEMENT_FEE = 'managementFee';
export const PARTNER_AIRBNB_COLUMN_MARKETING_TITLE = 'marketingTitle';
export const PARTNER_AIRBNB_COLUMN_NO_REFUND_DISCOUNT = 'noRefundDiscount';
export const PARTNER_AIRBNB_COLUMN_OCCUPANCY_TAXES = 'occupancyTaxes';
export const PARTNER_AIRBNB_COLUMN_OTHER_THINGS_TO_NOTE = 'otherThingsToNote';
export const PARTNER_AIRBNB_COLUMN_RATE_MULTIPLIER = 'rateMultiplier';
export const PARTNER_AIRBNB_COLUMN_MAPPING = {
    [PARTNER_AIRBNB_COLUMN_CANCEL_POLICY]: 'Cancel Policy',
    [PARTNER_AIRBNB_COLUMN_LONG_TERM_CANCEL_POLICY]: 'Long-Term Cancel Policy',
    [PARTNER_AIRBNB_COLUMN_NO_REFUND_DISCOUNT]: 'No Refund Discount',
    [PARTNER_AIRBNB_COLUMN_OCCUPANCY_TAXES]: 'Occupancy Taxes',
    [PARTNER_AIRBNB_COLUMN_OTHER_THINGS_TO_NOTE]: 'Other Things To Note',
    [PARTNER_AIRBNB_COLUMN_INSTANT_BOOKING]: 'Instant Booking',
    [PARTNER_AIRBNB_COLUMN_RATE_MULTIPLIER]: 'Multiplier',
    [PARTNER_AIRBNB_COLUMN_BASE_GUESTS]: 'Base Guests',
    [PARTNER_AIRBNB_COLUMN_GUEST_RATE]: 'Addtl Guest Rate',
    [PARTNER_AIRBNB_COLUMN_CLEANING_FEE]: 'Cleaning Fee',
    [PARTNER_AIRBNB_COLUMN_SHORT_TERM_CLEANING_FEE]: 'Short-Term Cleaning Fee',
    [PARTNER_AIRBNB_COLUMN_MANAGEMENT_FEE]: 'Mgmt Fee',
    [PARTNER_AIRBNB_COLUMN_COMMUNITY_FEE]: 'Community Fee',
    [PARTNER_AIRBNB_COLUMN_PET_FEE]: 'Pet Fee',
    [PARTNER_AIRBNB_COLUMN_MARKETING_TITLE]: 'Marketing Title',
};
export const PARTNER_AIRBNB_LISTING_STATUS_UNKNOWN = 'UNKNOWN';
export const PARTNER_AIRBNB_LISTING_STATUS_NOT_CREATED = 'NOT_CREATED';
export const PARTNER_AIRBNB_LISTING_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const PARTNER_AIRBNB_LISTING_STATUS_LISTED = 'LISTED';
export const PARTNER_AIRBNB_LISTING_STATUS_UNLISTED = 'UNLISTED';
export const PARTNER_AIRBNB_LISTING_STATUS_MAPPING = {
    [PARTNER_AIRBNB_LISTING_STATUS_UNKNOWN]: 'Unknown',
    [PARTNER_AIRBNB_LISTING_STATUS_NOT_CREATED]: 'Not Created',
    [PARTNER_AIRBNB_LISTING_STATUS_IN_PROGRESS]: 'In Progress',
    [PARTNER_AIRBNB_LISTING_STATUS_LISTED]: 'Listed',
    [PARTNER_AIRBNB_LISTING_STATUS_UNLISTED]: 'Unlisted',
};
export const PARTNER_AIRBNB_APPROVAL_STATUS_NOT_CREATED = 'NOT_CREATED';
export const PARTNER_AIRBNB_APPROVAL_STATUS_CREATED = 'CREATED';
export const PARTNER_AIRBNB_APPROVAL_STATUS_APPROVED = 'APPROVED';
export const PARTNER_AIRBNB_APPROVAL_STATUS_REJECTED = 'REJECTED';
export const PARTNER_AIRBNB_APPROVAL_STATUS_MAPPING = {
    [PARTNER_AIRBNB_APPROVAL_STATUS_NOT_CREATED]: 'Not Created',
    [PARTNER_AIRBNB_APPROVAL_STATUS_CREATED]: 'Created',
    [PARTNER_AIRBNB_APPROVAL_STATUS_APPROVED]: 'Approved',
    [PARTNER_AIRBNB_APPROVAL_STATUS_REJECTED]: 'Rejected',
};
export const PARTNER_AIRBNB_QUALITY_STATUS_UNKNOWN = 'UNKNOWN';
export const PARTNER_AIRBNB_QUALITY_STATUS_GOOD = 'GOOD';
export const PARTNER_AIRBNB_QUALITY_STATUS_WARN = 'WARN';
export const PARTNER_AIRBNB_QUALITY_STATUS_SUSPEND = 'SUSPEND';
export const PARTNER_AIRBNB_QUALITY_STATUS_MAPPING = {
    [PARTNER_AIRBNB_QUALITY_STATUS_UNKNOWN]: 'Unknown',
    [PARTNER_AIRBNB_QUALITY_STATUS_GOOD]: 'Good',
    [PARTNER_AIRBNB_QUALITY_STATUS_WARN]: 'Needs Attention',
    [PARTNER_AIRBNB_QUALITY_STATUS_SUSPEND]: 'Suspended',
};
export const PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED = 'none';
export const PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING = 'sync_all';
export const PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC = 'sync_rates_and_availability';
export const PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_MAPPING = {
    [PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED]: 'Not Connected',
    [PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING]: 'Sync Everything',
    [PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC]: 'Limited Sync',
};
